import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/prorated-rent-calculator',
  component: () => import('../../routes/ProratedRentCalculator.svelte'),
  card: {
    id: 'prorated-rent-calculator',
    title: 'Prorated Rent Calculator',
    description: 'Calculate prorated rent for partial-month occupancy when moving in or out mid-lease.',
    icon: 'home',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/prorated-rent-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Prorated Rent Calculator – Free Prorated Rent Calculator',
    description: 'Free prorated rent calculator for landlords and tenants. Calculate rent for partial months when moving in or out mid-lease. Supports move-in and move-out scenarios.',
  },
};

export default meta;
